import * as actions from "./actions";
import state from "./state";
import * as mutations from "./mutations";
import * as getters from "./getters";

export default {
  namespaced: true,
  actions,
  state,
  mutations,
  getters
};
